import { useState } from 'react'
import { InformationCircleIcon } from '@heroicons/react/20/solid'

import { Tooltip, TooltipTrigger, TooltipContent } from '~/components/ui/tooltip'

export const InfoTooltip = ({
  description,
  align = 'end',
}: {
  description: string
  align?: 'start' | 'end'
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setOpen(!open)
          }}
          className="ml-2 text-neutral-400 hover:text-neutral-600 focus-ring-brand p-1 -m-1 cursor-pointer"
          aria-label="Help"
        >
          <InformationCircleIcon className="h-4 w-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" align={align}>
        <p className="max-w-xs whitespace-normal text-sm">{description}</p>
      </TooltipContent>
    </Tooltip>
  )
}
